module.exports = __webpack_public_path__ + "proforma_portfolio.637321970226a48d1c42ddc984fe6196.png";